import { useTranslation } from "react-i18next";
import { ONBOARDING_SEGMENTS } from "../../../constants";
import StepHeading from "./StepHeading";

const SEGMENTS = [
  { value: ONBOARDING_SEGMENTS.COACH, titleKey: "coachTitle", descKey: "coachDesc" },
  { value: ONBOARDING_SEGMENTS.GYM, titleKey: "gymTitle", descKey: "gymDesc" },
  { value: ONBOARDING_SEGMENTS.BOTH, titleKey: "bothTitle", descKey: "bothDesc" },
];

// Step 2 — segmentation. Drives which products surface on step 3.
const StepAboutYou = ({ current, segment, onSelectSegment }) => {
  const { t } = useTranslation("auth");

  return (
    <div className="step-body step-about-you">
      <StepHeading
        current={current}
        title={t("onboardingWizard.aboutYou.title")}
        subtitle={t("onboardingWizard.aboutYou.subtitle")}
      />

      <span className="field-eyebrow">{t("onboardingWizard.aboutYou.iAmA")}</span>

      <div className="segment-cards">
        {SEGMENTS.map((s) => (
          <button
            key={s.value}
            type="button"
            className={`segment-card ${segment === s.value ? "selected" : ""}`}
            aria-pressed={segment === s.value}
            onClick={() => onSelectSegment(s.value)}
          >
            <span className="segment-radio" />
            <span className="segment-title">
              {t(`onboardingWizard.aboutYou.${s.titleKey}`)}
            </span>
            <span className="segment-desc">
              {t(`onboardingWizard.aboutYou.${s.descKey}`)}
            </span>
          </button>
        ))}
      </div>

      <p className="info-note">{t("onboardingWizard.aboutYou.note")}</p>

      <input type="hidden" name="onboardingSegment" value={segment || ""} />
    </div>
  );
};

export default StepAboutYou;
